import React, { createContext, useContext } from "react"

type DrawerContextType = {
  showTopBorder: boolean
  setShowTopBorder: React.Dispatch<React.SetStateAction<boolean>>
  showBottomBorder: boolean
  setShowBottomBorder: React.Dispatch<React.SetStateAction<boolean>>
}

const DrawerContext = createContext<DrawerContextType | undefined>(undefined)

export const DrawerContextProvider: React.FC<
  DrawerContextType & { children: React.ReactNode }
> = ({
  children,
  showTopBorder,
  setShowTopBorder,
  showBottomBorder,
  setShowBottomBorder,
}) => {
  const value = {
    showTopBorder,
    setShowTopBorder,
    showBottomBorder,
    setShowBottomBorder,
  }

  return (
    <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>
  )
}

export const useDrawerContext = (): DrawerContextType => {
  const context = useContext(DrawerContext)
  if (context === undefined) {
    throw new Error("useDrawerContext must be used within a Drawer component")
  }
  return context
}
